import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
 import { updateTemplateOBj } from './template.action';
 
export class TemplateQryPModel{
    
    obj:any;
 
 }
 @State<TemplateQryPModel>({
     name: 'templateObj',
     defaults: {
       
          obj:null,
        
      }
 })
 @Injectable()
 export class TemplateState {
 
     constructor( ) {
     }
 
     @Selector()
     static getTemplateObj(state: TemplateQryPModel) {
         return state;
     }
    

     @Action(updateTemplateOBj)
     updateTemplateOBj({getState, patchState}: StateContext<TemplateQryPModel>, {payload}: updateTemplateOBj) {
         const state = getState();
        //  console.log(payload)
         patchState({
            obj:payload
            });
     }
     
    } 